import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FlashMessagesService } from "angular2-flash-messages";
export interface DialogData {
  name: string;
  data: any;
}


@Component({
  selector: 'app-copy-dialog',
  templateUrl: './copy-dialog.component.html',
  styleUrls: ['./copy-dialog.component.css']
})
export class CopyDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<CopyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _flashMessagesService: FlashMessagesService
  ) {}

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  copyToClipboard(text: string) {
    const textField = document.createElement('textarea');
    textField.innerText = text;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();

    const message = `Copied to clipboard: ${text}`;
    this._flashMessagesService.show(message, {
      cssClass: "alert-success",
      timeout: 5000
    });
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-stores/copy-dialog/copy-dialog.component.ts